var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":"","max-width":_vm.maxWidth,"color":_vm.color,"content-class":"content px-4 py-2"},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('span',_vm._g(_vm._b({domProps:{"innerHTML":_vm._s(_vm.activator)}},'span',attrs,false),on))]}}])},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.title)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }